module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Statistics \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Personankomster")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                    " + _vm._s(_vm.guests) + " personankomster\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gæstenætter")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                    " + _vm._s(_vm.guestNights) + " gæstenætter\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Værelsesnætter")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                    " + _vm._s(_vm.roomNights) + " værelsesnætter\n                                ")])])])])])])]], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1acf5bea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/Statistics.vue
// module id = 385
// module chunks = 1